export const createGaPush = (global = window) => {
    if (global.dataLayer === undefined) {
        // @TODO provide a "capped" array in order to prevent uncontrolled growth in case GA is not in place
        // eslint-disable-next-line no-param-reassign
        global.dataLayer = [];
    }
    return (event: unknown | unknown[]) => {
        if (global.dataLayer) {
            if (Array.isArray(event)) {
                event.forEach((e) => {
                    if (global.dataLayer) {
                        global.dataLayer.push(e);
                    }
                });
            } else {
                global.dataLayer.push(event);
            }
        }
    };
};
